import React, { useState } from 'react';
import { Download } from '../../Icons/index.js';
import THEME from '../../../theme.js';
import { styled } from 'styled-components';
import * as api from '@debbie/cortex/dist/api/bespoke/apcoa.js';
import { notifications } from '@debbie/cortex/dist/index.js';
import Loading from '../../Loading.js';
export const EINavZip = (props) => {
    if (!props.case)
        return React.createElement(React.Fragment, null);
    const [isDownloading, setIsDownloading] = useState(false);
    const downloadZip = async () => {
        if (isDownloading)
            return;
        try {
            setIsDownloading(true);
            const res = await api.getNavZip(props.case.id.toString());
            const link = document.createElement('a');
            link.href = `data:application/zip;base64,${res.value}`;
            link.download = `nav-${props.case.id}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (error) {
            notifications.notification({
                title: 'Kunne ikke hente zip-fil',
                subtitle: 'Måske eksisterer filen ikke i NAV',
            });
        }
        finally {
            setIsDownloading(false);
        }
    };
    return (React.createElement("div", { style: {
            backgroundColor: '#E6E6E6',
            padding: 8,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        React.createElement("div", null, "Filer fra NAV"),
        React.createElement(DownloadButton, { onClick: downloadZip, style: { cursor: isDownloading ? 'not-allowed' : 'pointer' } },
            "nav-",
            props.case && props.case.id,
            ".zip",
            React.createElement("div", { style: { width: 12, height: 12 } }, isDownloading ? React.createElement(Loading, { width: "12 px" }) : React.createElement(Download, null)))));
};
const DownloadButton = styled.div `
  background: #d3d3d3;
  border-radius: 16px;
  padding: 4px;
  font-size: 12px;
  gap: 4px;
  border: 1px solid ${THEME.COLOR_PRIMARY};
  display: flex;

  &:hover {
    background: #c0c0c0;
  }
`;
//# sourceMappingURL=EINavZip.js.map